import { defineMessages } from 'react-intl';

export const messages: {
	searchForAllApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	allApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchForJiraWorkItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraWorkItems: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	searchForAllApps: {
		id: 'search.quickFind.intentRouter.searchForAllApps',
		defaultMessage: 'Search for all apps',
		description: 'Label for the search for all apps intent router',
	},
	allApps: {
		id: 'search.quickFind.intentRouter.allApps',
		defaultMessage: 'All apps',
		description: 'Label for the all apps intent router',
	},
	searchForJiraWorkItems: {
		id: 'search.quickFind.intentRouter.searchForJiraWorkItems',
		defaultMessage: 'Search for Jira work items',
		description: 'Label for the search for Jira work items intent router',
	},
	jiraWorkItems: {
		id: 'search.quickFind.intentRouter.jiraWorkItemsJql',
		defaultMessage: 'Jira work items (JQL)',
		description: 'Label for the Jira work items intent router',
	},
});
